export const TILE_STYLE_URL =
  (import.meta.env.VITE_TILE_STYLE_URL as string | undefined) ??
  'https://tiles.openfreemap.org/styles/liberty';

/** Pflicht nach ODbL – erscheint auf der Karte und auf jedem Export. */
export const OSM_ATTRIBUTION = '© OpenStreetMap-Mitwirkende';

/** Startansicht: Testort Eicklingen (Samtgemeinde Flotwedel). */
export const START_ANSICHT = {
  center: [10.1815, 52.5545] as [number, number],
  zoom: 15.5,
};
